import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import { DatePicker } from 'components';
import { Box, Typography, Stack } from '@mui/material';
import Utils from 'commons/utils';
import ApiServices from 'services';
import {
    BsArrowDownCircle,
} from 'react-icons/bs';
import { ContainerHeader, ButtonView, ButtonExport } from './styles';
import { debounce } from 'lodash';
import MetricsTable from 'components/metrics-table';

const START_DATE = moment().startOf('month').format();
const END_DATE = moment().endOf('date').format();

const DEFAULT_FILTER = {
    // pageNumber: 1,
    // pageSize: 10,
    fromDate: START_DATE,
    toDate: END_DATE,
};

function SalesCustomerStatusRp() {
    const [dataList, setDataList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [filter, setFilter] = useState(DEFAULT_FILTER);

    // search Date
    const [startDate, setStartDate] = useState(START_DATE);
    const [endDate, setEndDate] = useState(END_DATE);

    const [salesReps, setSalesReps] = useState([]);
    const [selectedSalesRep, setSelectedSalesRep] = useState('Tất cả');
    const [dataFilter, setDataFilter] = useState([]);

    const initData = (query) => {
        // setLoading(true);
        return ApiServices.getSalesLeadKPIReport(query ? query : filter)
            .then((res) => {
                if (res?.data) {
                    const newDataList = res?.data || [];
                    if (totalRecords !== newDataList.length) setTotalRecords(newDataList.length);
                    setDataList(newDataList);
                }
            })
            .catch((err) => console.warn('get Clients:', err))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        const fetchSalesReps = async () => {
            const reps = await ApiServices.getUserbyPermission()
                .then((res) => res?.data || [])
                .catch((err) => {
                    console.warn('get Clients:', err);
                    return [];
                });

            setSalesReps(reps);

            if (reps.length === 1 && dataList.length > 0) {
                const selectedCode = reps[0].code;
                setSelectedSalesRep(selectedCode);

                const filtered = dataList.filter(item => {
                    const firstPart = item.salesEmployeeName?.split(' - ')[0]?.trim();
                    return firstPart === selectedCode;
                });
                setDataFilter(filtered);
            } else {
                setDataFilter(dataList);
            }
        };

        fetchSalesReps();
    }, [dataList]);


    const timeoutGetData = useCallback(
        debounce((newFilter) => {
            initData(newFilter);
        }, 500),
        [],
    );
    useEffect(() => {
        timeoutGetData(filter);
    }, [filter]);

    const handleChangeStartDate = useCallback(
        (event) => {
            setStartDate(event.target.value);
        },
        [startDate],
    );
    const handleChangeEndDate = useCallback(
        (event) => {
            setEndDate(event.target.value);
        },
        [endDate],
    );

    const onFilterChange = ({ salesRep: newSalesRep }) => {
        setSelectedSalesRep(newSalesRep);
        if (newSalesRep === 'Tất cả') {
            setDataFilter(dataList);
        } else {
            const filtered = dataList.filter(item => {
                const firstPart = item.salesEmployeeName?.split(' - ')[0]?.trim();
                return firstPart === newSalesRep;
            });
            setDataFilter(filtered);
        }
    };

    const handleSearchDate = (startDateSearch, endDateSearch) => {
        console.log({ startDateSearch, endDateSearch });
        if (!startDateSearch || !endDateSearch) return;
        setFilter((prev) => ({ ...prev, fromDate: startDateSearch, toDate: endDateSearch }));
    };

    const handleExportClient = () => {
        setLoading(true);
        return ApiServices.exportExcelGetSalesLeadKPIReport()
            .then((res) => {
                if (res?.data) {
                    Utils.exportTemplate(
                        res?.data,
                        `Báo_cáo_hoạt_động_bán_hàng_nhân_viên_${Utils.formatSimpleDate(moment())}.xlsx`,
                    );
                }
            })
            .catch((err) => {
                console.log('Export Client file error:', err);
                window.UIMessage?.error('Tải thất bại !!!');
            })
            .finally(() => setLoading(false));
    };

    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Typography variant="h6" component="h6" sx={{ marginBottom: '10px' }}>
                    Báo cáo hoạt động bán hàng nhân viên
                </Typography>

                <ContainerHeader sx={{ mt: 4 }}>
                    <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        spacing={2}
                        alignItems={{ xs: 'stretch', md: 'center' }}
                        flexWrap="wrap"
                    >
                        <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
                            <DatePicker
                                sx={{ mb: { xs: 2, md: 0 } }}
                                size="small"
                                onChange={handleChangeStartDate}
                                value={startDate}
                                label="Từ ngày"
                                slotProps={{ textField: { size: 'small', fullWidth: true } }}
                            />
                        </Box>

                        <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
                            <DatePicker
                                sx={{ mb: { xs: 2, md: 0 } }}
                                size="small"
                                onChange={handleChangeEndDate}
                                value={endDate}
                                label="Đến ngày"
                                slotProps={{ textField: { size: 'small', fullWidth: true } }}
                            />
                        </Box>

                        <Box
                            className="select-control"
                            sx={{
                                alignItems: 'center',
                                width: { xs: '100%', sm: 'auto' },
                            }}
                        >
                            <label style={{ marginRight: 8, marginBottom: 4 }}>Tên nhân viên sales:</label>
                            <select
                                value={selectedSalesRep || 'Tất cả'}
                                onChange={(e) => onFilterChange({ salesRep: e.target.value })}
                                style={{
                                    padding: '4px 8px',
                                    borderRadius: 4,
                                    border: '1px solid #ccc',
                                    maxWidth: 400,
                                }}
                            >
                                {salesReps.length > 1 && <option value="Tất cả">Tất cả</option>}
                                {Array.from(new Map(salesReps.map(rep => [rep.code, rep.name]))).map(([code, name]) => (
                                    <option key={code} value={code}>
                                        {name}
                                    </option>
                                ))}
                            </select>

                        </Box>

                        <ButtonView
                            onClick={() => handleSearchDate(startDate, endDate)}
                            sx={{ width: { xs: '100%', sm: 'auto' } }}
                        >
                            Xem
                        </ButtonView>

                        <ButtonExport
                            variant="outlined"
                            startIcon={<BsArrowDownCircle />}
                            onClick={handleExportClient}
                            sx={{ width: { xs: '100%', sm: 'auto' } }}
                        >
                            Tải excel
                        </ButtonExport>
                    </Stack>
                </ContainerHeader>
                <MetricsTable
                    filter={filter}
                    rows={dataFilter}
                    totalRecords={totalRecords}
                    loading={loading}
                    onPageChange={(newFilter) => {
                        setFilter((prev) => ({ ...prev, ...newFilter }));
                    }}
                />
            </Box>

        </>
    );
}
export { SalesCustomerStatusRp };
